<template>
  <div class="mine">
    <div class="top">
      <div class="setting">
        <div style="float: left; margin: 10px">
          <van-icon name="chat-o" color="#fff" size="28"  @click="$router.push({name:'service'})"/>
        </div>
        <div style="float: right; margin: 0px 10px">
          <van-popover
            class="lang-btn"
            v-model="showPopover"
            trigger="click"
            :actions="langlst"
          >
            <ul>
              <li
                @click="changeLang(item)"
                v-for="(item, index) in langlst"
                :key="index"
                class="lang-item-box"
              >
                <div style="float: left; height: 30px; line-height: 30px">
                  {{ item.language_name }}
                </div>
              </li>
            </ul>
            <template #reference>
              <div>
                {{ getlangName(lang) }}
              </div>
            </template>
          </van-popover>
        </div>
      </div>
      <div class="avatar">
        <van-image
          round
          width="4.2rem"
          height="4.2rem"
          :src="userInfo.header_img"
        />
        <div class="me">
          <div
            class="user"
            style="flex-direction: initial; align-items: center"
          >
            <p style="padding-bottom: 0px">{{ userInfo.username }}</p>
          </div>
          <div class="ps">
            <span style="padding-left: 0px; margin: 4px 0px 2px"
              >{{ $t('mine.creditscore') }}:{{ userInfo.score }}</span
            >
          </div>
          <div class="ps">
            <div class="proess">
              <span :style="'width: '+userInfo.num+'%'"></span>
            </div>
            <span>{{ $t('mine.points') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="integral">
        <div @click="$router.push({name:'recharge'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(0, 0, 0); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/qianbao.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.recharge') }}</font
              ></font
            ></span
          >
        </div>
        <div @click="toWithdrawal()">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(0, 0, 0); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/piao.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.withdraw') }}</font
              ></font
            ></span
          >
        </div>
      </div>
      <div class="mineJf animate__animated animate__flipInX">
        <div class="title">
          <p>
            <font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.available') }}</font
              ></font
            >
          </p>
          <h1>
            <font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ userInfo.money }}</font
              ></font
            ><span style="font-size: 14px; margin-left: 5px"
              ><font dir="auto" style="vertical-align: inherit"
                ><font dir="auto" style="vertical-align: inherit"
                  >（{{ $t('common.unit') }}）</font
                ></font
              ></span
            >
          </h1>
        </div>
        <div class="title">
          <p>
            <font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.frozen') }}</font
              ></font
            >
          </p>
          <h1>
            <font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ userInfo.freeze_amount }}</font
              ></font
            ><span style="font-size: 14px; margin-left: 5px"
              ><font dir="auto" style="vertical-align: inherit"
                ><font dir="auto" style="vertical-align: inherit"
                  >（{{ $t('common.unit') }}）</font
                ></font
              ></span
            >
          </h1>
        </div>
        <div class="reload">
          <div>
            <i
              class="van-badge__wrapper van-icon"
              style="
                background-color: rgb(255, 255, 255);
                font-size: 1rem;
                border-radius: 50%;
                padding: 8px;
              "
              ><!----><img @click="getUserInfo()"
                class="van-icon__image"
                src="../../assets/img/mine/reload.png"
              /><!----></i
            >
          </div>
        </div>
      </div>
      <div class="list animate__animated animate__fadeIn">
        <div @click="$router.push({name:'infomation'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/zhangdan.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.information') }}</font
              ></font
            ></span
          >
        </div>
        <div @click="$router.push({name:'points'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/shujuku.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.pointshistory') }}</font
              ></font
            ></span
          >
        </div>
        <div @click="$router.push({name:'withddrawrecord'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/zhangdan2.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.withdrawdetails') }}</font
              ></font
            ></span
          >
        </div>
        <div @click="$router.push({name:'gamerecord'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/youxi.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.giftrecord') }}</font
              ></font
            ></span
          >
        </div>
        <div  @click="$router.push({name:'matter'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/diwu.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.matters') }}</font
              ></font
            ></span
          >
        </div>
        <div @click="$router.push({name:'mymove'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/dianying.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.watch') }}</font
              ></font
            ></span
          >
        </div>
        <div @click="$router.push({name: 'changepwd'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/suo.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.loginpwd') }}</font
              ></font
            ></span
          >
        </div>
        <div @click="$router.push({name:'bank'})">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/qianbao.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.mybank') }}</font
              ></font
            ></span
          >
        </div>
        <div @click="$router.push({name: 'changeusrpwd'})" style="visibility: hidden;">
          <i
            class="van-badge__wrapper van-icon"
            style="color: rgb(134, 134, 134); font-size: 26px"
            ><img
              class="van-icon__image"
              src="../../assets/img/mine/anquan.png" /></i
          ><span
            ><font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                >{{ $t('mine.usrpwd') }}</font
              ></font
            ></span
          >
        </div>
        
      </div>
    </div>
    <div style="margin: 16px">
      <van-button @click="logout" class="btn">{{
        $t("mine.cancellation")
      }}</van-button>
    </div>
    <FooterView />
  </div>
</template>

<script>
import { TokenLangKey, setTokenbyName, getTokenbyName } from "@/utils/cookies";
import FooterView from "@/components/Footer/index.vue";

export default {
  name: "MineView",
  components: { FooterView },
  data() {
    return {
      lang: null,
      langlst: [
        { language_name: "English", file_name: "en_us" }, //英语
        { language_name: "हिंदी", file_name: "hi_hi" }, //"印地"
      ],
      showPopover: false,
      userInfo:{}
    };
  },
  mounted() {
    this.lang = getTokenbyName(TokenLangKey);
    if (!this.lang) this.lang = "en_us";

    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
      return
    } 
    this.getUserInfo()
  },
  methods: {
    logout(){
      localStorage.setItem("token", '');
      this.$router.push({ path: "/login" });
    },
    getlangName(val) {
      let reuslt = val;
      this.langlst.forEach((item) => {
        if (val == item.file_name) {
          reuslt = item.language_name;
        }
      });
      return reuslt;
    },
    changeLang(item) {
      this.showPopover = false;
      this.lang = item.file_name;
      setTokenbyName(TokenLangKey, item.file_name);
      location.reload();
    },
    getUserInfo () {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
          console.log(this.userInfo)
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    toWithdrawal(){
      
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.$router.push({name:'withdrawal'})
          } else {
            this.$router.push({name:'bankinfo'})
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.mine {
  width: 100%;
  min-height: 100%;
  background: #f2f2f5;
  padding-bottom: 60px;
  .top {
    width: 100%;
    height: 13.33333rem;
    background: url("../../assets/img/mine/usertop.png") no-repeat bottom / 160%;
    .setting {
      width: 100%;
      text-align: left;
      display: flex;
      justify-content: space-between;
    }
    .avatar {
      width: 80%;
      padding: 0 6%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 1.33333rem;
      .me {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 1.33333rem;
        flex: 1;
        .user {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          p {
            font-size: 1rem;
            color: #fff;
            padding-bottom: 0.33333rem;
          }
        }
        .ps {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          span {
            padding-left: 0.33333rem;
            color: #ffe0f6;
            font-size: 0.73333rem;
          }
        }
        .proess {
          width: 40%;
          height: 0.26667rem;
          background: #e5d3cb;
          margin: 0.46667rem 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-radius: 0.66667rem;
          overflow: hidden;
          span {
            background: #fff;
            height: 100%;
            width: 50%;
          }
        }
      }
    }
  }
  .center {
    width: 94%;
    margin: -10% auto 0;
    .integral {
      width: 100%;
      background: #fff;
      display: flex;
      justify-content: center;
      padding: 1rem 0;
      align-items: center;
      border-radius: 0.33333rem;
      box-shadow: 0 0.13333rem 0.2rem #0000000a;
      position: relative;
      z-index: 999;
      div {
        width: 50%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          margin-left: 0.66667rem;
          color: #432989;
          font-weight: 600;
        }
      }
    }
    .integral::before {
      content: "";
      position: absolute;
      width: 3px;
      height: 1.33333rem;
      border-radius: 0.66667rem;
      background: #f2f2f5;
    }
    .mineJf {
      background: #a06098;
      display: flex;
      justify-content: center;
      padding: 0.86667rem;
      margin-top: 0.66667rem;
      border-radius: 0.33333rem;
      box-shadow: 0 0.13333rem 0.2rem #0000000a;
      .title {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding: 0 0 0.66667rem;
        margin: 0 auto;
        justify-content: flex-start;
        align-items: center;
        p {
          color: #fff;
          font-size: 0.93333rem;
          font-weight: 600;
        }
        h1 {
          color: #fff;
          font-size: 1.3rem;
          margin-top: 0.33333rem;
        }
      }
      .reload {
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .list {
      width: 100%;
      background: #fff;
      display: flex;
      justify-content: center;
      padding: 0.86667rem 0;
      align-items: center;
      flex-wrap: wrap;
      border-radius: 0.33333rem;
      box-shadow: 0 0.13333rem 0.2rem #0000000a;
      margin-top: 0.8rem;
      div {
        width: 26%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1rem 0 1rem 6%;
        text-align: center;
        i {
          padding: 0.2rem;
        }
        span {
          color: #432788;
          padding: 0.53333rem 0;
          font-size: 14px;
        }
      }
    }
  }
}
.lang-btn {
  float: right;
  text-align: center;
  color: #fff;
  border-radius: 10px;
  border: 1px solid #fff;
  height: 30px;
  line-height: 30px;
  padding: 0px 10px;
  margin: 10px 10px;
}
.lang-item-box {
  padding: 8px 14px;
}
</style>
